var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBottombarContentBank = function SvgBottombarContentBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#525252",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.5 13.5h-15a.75.75 0 0 0-.75.75v4.5c0 .414.336.75.75.75h15a.75.75 0 0 0 .75-.75v-4.5a.75.75 0 0 0-.75-.75M19.5 4.5h-15a.75.75 0 0 0-.75.75v4.5c0 .414.336.75.75.75h15a.75.75 0 0 0 .75-.75v-4.5a.75.75 0 0 0-.75-.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#525252",
    d: "M16.875 8.625a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25M16.875 17.625a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"
  })));
};
export default SvgBottombarContentBank;